У Вас нет сохраненных поисков,
Выберите параметры для сохранения
<button [routerLink]="['/kazakhstan']">
    ПОИСК
</button>

